import { axios, loginApi, cached } from '@/axios.config';
import router from '@/router';
import Cookies from 'js-cookie';
import Config from '@/config';
import * as navigator from '@/lib/navigator';
import { resetSentry } from '@/sentry.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';

export const state = {};

export const actions = {
  getAccessToken(state, { username, password, mfaToken, grantType }) {
    let apiType = navigator.appEnv;
    let appType = navigator.appDomain;

    if (apiType !== 'prod' && apiType !== 'next') {
      apiType = Cookies.get('api_type');
      appType = Cookies.get('app_type');

      if (!apiType || !appType)
        throw new Error('Cookie(api_type) or Cookie(app_type) is not valid.');
    }

    // const apiType = Cookies.get('api_type');
    // const appType = Cookies.get('app_type');
    //
    // if (!apiType || !appType) throw new Error('Cookie(api_type) or Cookie(app_type) is not valid.');

    const clientId = Config.clientId[appType][apiType];
    const clientSecret = Config.clientSecret[appType][apiType];

    const formData = new FormData();
    formData.append('grant_type', grantType);
    formData.append('client_id', clientId);
    formData.append('client_secret', clientSecret);
    formData.append('username', username);
    formData.append('password', password);
    formData.append('scope', 'openid');
    if (mfaToken) {
      formData.append('mfa_token', mfaToken);
    }

    const url = 'access_token';

    mockAdapter(loginApi, 'post', url, 'postToken', 200);

    return loginApi
      .post(url, formData)
      .then(r => r.data['access_token'])
      .catch(err => {
        return Promise.reject(err);
      });
  },

  async getAccessTokenViaSaml(_, { token }) {
    try {
      let apiType = Cookies.get('api_type') || navigator.appEnv;
      let appType = Cookies.get('app_type') || navigator.appDomain;

      if (apiType !== 'prod' && apiType !== 'next') {
        if (apiType === 'localhost' || apiType === 'localhost') {
          apiType = 'dev';
          appType = 'alphaus';
        }
        Cookies.set('api_type', apiType, { expires: Config.tokenExpire });
        Cookies.set('app_type', appType, { expires: Config.tokenExpire });
      }

      const clientId = Config.clientId[appType][apiType];
      const clientSecret = Config.clientSecret[appType][apiType];

      const formData = new FormData();
      formData.append('client_id', clientId);
      formData.append('client_secret', clientSecret);
      formData.append('token', token);

      const r = await loginApi.post('/wavepro/saml/login', formData);
      return r.data['access_token'];
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  },

  checkToken() {
    let storedAccessToken = '';

    // Wave for Resellerログインの場合
    const waveForResellerToken = Cookies.get('mo_wave_for_reseller_access_token', {
      path: Config.cookiePath,
    });

    if (waveForResellerToken) {
      storedAccessToken = waveForResellerToken;
    } else {
      storedAccessToken = Cookies.get('mo_access_token', { path: Config.cookiePath });
    }

    if (storedAccessToken) {
      return storedAccessToken;
    } else {
      return Promise.reject('Access token not found.');
    }
  },

  setAccessToken(state, token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // X-User is Base64 Encoded value. User information that can be obtained from Authorization.
    // format: root user "{"root":true,"user_id":"user id value"}"
    // format: subuser user "{"root":false,"user_id":"user id value", "username":"sub user name value"}"
    // axios.defaults.headers.common[
    //   'X-User'
    // ] = `"{"root":true,"user_id":"user id value"}" Base64 Encoded value is e3Jvb3Q6dHJ1ZSx1c2VyX2lkOnVzZXIgaWQgdmFsdWV9Cg==`;

    return Promise.resolve();
  },

  logout({ commit }) {
    Cookies.remove('mo_access_token', { path: Config.cookiePath });

    // Wave for Resellerのトークンを削除
    Cookies.remove('mo_wave_for_reseller_access_token', { path: Config.cookiePath });
    //remove report filter settings from local storage
    localStorage.removeItem('reportFilterSettings');
    commit('usageReports/reset', null, { root: true });
    commit('accounts/reset', null, { root: true });
    commit('status/reset', null, { root: true });
    // intercom
    // window.Intercom('shutdown');

    // reset cached
    cached.flushAll();
    // close the cached
    cached.close();

    router.push('/login').catch(() => {});
    resetSentry();
  },

  loginRbac() {
    const waveAccessToken = Cookies.get('mo_access_token', { path: Config.cookiePath });
    Cookies.set('mo_access_token', waveAccessToken, {
      expires: Config.tokenExpire,
      path: Config.cookieUsersPath,
    });
    Cookies.set('mo_user_type', 'wave', { path: Config.cookieUsersPath });

    let base = `${navigator.locationOrigin}`;

    if (navigator.appEnv === 'localhost') {
      const port = Cookies.get('rbac_port');
      if (!port) throw new Error('Should set "port" on login page.');

      base = `${navigator.locationOrigin}:${port}`;
    }

    const rbacUrl = `${base}/users/`;
    if (rbacUrl) window.open(rbacUrl, '_blank');
    else throw new Error(`Failed to create Invoice URL. baseDomain: ${base}`);
  },
};

export const mutations = {};

export const getters = {};
